import type { UUID } from '@/types/Id'

const DEFAULT_PURSUIT_BOOKMARK_IDS_LIMIT = 10000
const DEFAULT_PURSUIT_BOOKMARK_IDS_OFFSET = 0

interface PursuitBookmarkIdsQueryKeyArgs {
  orgId: UUID | ''
  limit?: number
  offset?: number
}

interface PursuitsByIdsQueryKeyArgs {
  orgId: UUID | ''
  pursuitIds: UUID[]
}

interface PursuitBookmarkCheckQueryKeyArgs {
  orgId: UUID | ''
  pursuitId: UUID | ''
}

/**
 * Query keys for bookmark IDs (lightweight, used for optimistic updates)
 */
export const pursuitBookmarkIdsQueryKeys = {
  all: () => ['pursuit-bookmark-ids'] as const,
  organization: (args: PursuitBookmarkIdsQueryKeyArgs) =>
    [
      'pursuit-bookmark-ids',
      args.orgId,
      args.limit ?? DEFAULT_PURSUIT_BOOKMARK_IDS_LIMIT,
      args.offset ?? DEFAULT_PURSUIT_BOOKMARK_IDS_OFFSET,
    ] as const,
}

/**
 * Query keys for fetching pursuits by specific IDs.
 * Uses sorted, joined string to ensure stable key reference.
 */
export const pursuitsByIdsQueryKeys = {
  all: () => ['pursuits-by-ids'] as const,
  byIds: (args: PursuitsByIdsQueryKeyArgs) =>
    [
      'pursuits-by-ids',
      args.orgId,
      args.pursuitIds.toSorted().join(','),
    ] as const,
}

export const pursuitBookmarkCheckQueryKeys = {
  all: () => ['pursuit-bookmark-check'] as const,
  check: (args: PursuitBookmarkCheckQueryKeyArgs) =>
    ['pursuit-bookmark-check', args.orgId, args.pursuitId] as const,
}
